export const LOADING_START = (state) => {
  state.loading = true
}

export const LOADING_DONE = (state) => {
  state.loading = false
}

export const SET_DATA = (state, data) => {
  state.data = data
}

export const SET_ID = (state, id) => {
  state.id = id
}

export const SET_SCHEMA = (state, schema) => {
  state.schema = schema
}

export const SET_VIEW_ENTITY_TYPE = (state, type) => {
  state.viewEntityType = type
}



// WEBPACK FOOTER //
// ./src/store/modules/resource/mutations.js